module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVRIie2OPRLBUBRGz7uhFD9PSmuIVdiQxiaMfbAChT1oU1PKhNTJPEWGISKMebp7unu/c+98oCiKonyJAUjTdOKC7grcrFq7nRNZRGGY1A98uaYKO3tgVLvLTFnE1trD8yM/rlSNXkKAoQu6y8eFT9eczpcc6DUIAPl40O/fBp+uvAnuxT/kP7sCbtfyaVvbeHPFiSyArCFPpSzmzzX9uRKFYWLKIgazAXIgd7A2ZTG11h4fL/7lKoqiKK1cAdz2j1jaAek4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/threedot.png
// module id = 893
// module chunks = 0